import React, { useContext, useEffect, useState } from 'react'
import { LeagueContext } from '../../../../Context'
import { FeedItem } from '../../../../Api'
import { FeedCard } from '../../../../Components/Feed/FeedCard'
import { HSpace } from '../../../../Components/Layout'
import { CardLoading } from '../../../../Components/Loading'

export const FeedHighlightSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  //Setting two most trending feed items
  const [feedHighlights, setFeedHighlights] = useState<FeedItem[]>([])
  const { feed, feedLoading } = useContext(LeagueContext)!

  useEffect(() => {
    if (feed?.trending && feed.trending.length > 1) {
      let slicedFeed = feed.trending.slice(0, 1)
      setFeedHighlights(slicedFeed)
    }
  }, [feed])

  return (
    <div>
      {feedLoading ? (
        <>
          <CardLoading size="lg" />
          <CardLoading size="lg" />
        </>
      ) : (
        feedHighlights.length > 0 &&
        feedHighlights.map((art, index) => (
          <React.Fragment key={index}>
            <FeedCard
              feedItem={art}
              key={art.id}
              section={`home_trending_${index + 1}`}
              size={'home_featured'}
            />
            <HSpace />
          </React.Fragment>
        ))
      )}
    </div>
  )
}
